var _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuru(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5.75701,
    height: 22,
    rx: 2.8785,
    transform: "matrix(1 0 0 -1 3 25)",
    fill: "#A4FC67"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5.75701,
    height: 22,
    rx: 2.8785,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 3 3)",
    fill: "#A4FC67",
    fillOpacity: 0.66
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5.75701,
    height: 22,
    rx: 2.8785,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 3 19.243)",
    fill: "#A4FC67",
    fillOpacity: 0.66
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 5.75701,
    height: 13.4935,
    rx: 2.8785,
    transform: "matrix(1 0 0 -1 19.2432 25)",
    fill: "#A4FC67",
    fillOpacity: 0.66
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuru);
export default __webpack_public_path__ + "static/media/guru.d27033527d66c5d9354c48e14cd745f7.svg";
export { ForwardRef as ReactComponent };